export default [
  {
    path: '/Profile',
    name: 'Profile',
    component: () => import('@/views/users/Profile.vue'),
    meta: {
      title: 'Profile',
      requiresAuth: true ,
      requiresAmazon: true,
    },
  },
  {
    path: '/users',
    component: () => import('@/views/users/UsersList.vue'),
    meta: { 
      title: 'Users', 
      requiresAuth: true,
      requiresAmazon: true,
      permission: 'user_dashboard',
    },
  },
  {
    path: '/users/invite-user',
    component: () => import('@/views/users/UserForm.vue'),
    meta: { 
      title: 'Invite User', 
      requiresAuth: true,
      requiresAmazon: true,
      permission: 'create_user',
    },
  },
  {
    path: '/users/edit/:id',
    component: () => import('@/views/users/UserForm.vue'),
    meta: { 
      title: 'Edit User', 
      requiresAuth: true,
      requiresAmazon: true,
      permission: 'edit_user',
    },
  }
]